import { Field, FieldProps, useFormikContext } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';
import ReactDatePicker from 'react-datepicker';
import { UID } from 'react-uid';
import { Help } from '../help';

export type DatepickerProps = {
  controlId: string;
  label?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  help?: string;
};

export const DATE_FORMAT = 'yyyy/MM/dd';

export const Datepicker: React.FC<React.PropsWithChildren<DatepickerProps>> = ({
  controlId,
  label,
  disabled = false,
  required = false,
  className = '',
  help,
}) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  function handleChange(value: Date | [Date | null, Date | null] | null) {
    setFieldTouched(controlId, true);
    setFieldValue(controlId, value ? value : '');
  }

  return (
    <div className={`datepicker${className ? ` ${className}` : ''}`}>
      <Field name={controlId}>
        {({ field, meta }: FieldProps) => (
          <Form.Group controlId={controlId} className="form-group">
            {label && (
              <Form.Label className={required ? 'fw-bold' : ''}>
                {label} {required ? ' *' : ''}
              </Form.Label>
            )}
            {help && <Help placement="top">{help}</Help>}
            <UID>
              {(id) => (
                <ReactDatePicker
                  id={`datepicker_${id}`}
                  dateFormat={DATE_FORMAT}
                  placeholderText={DATE_FORMAT.toLowerCase()}
                  selected={field.value}
                  onChange={(value) => handleChange(value)}
                  onBlur={field.onBlur}
                  autoComplete="off"
                  disabled={disabled}
                  className={`form-control${!meta.error && meta.touched ? ' is-valid' : ''}${
                    !!meta.error && meta.touched ? ' is-invalid' : ''
                  }`}
                />
              )}
            </UID>
            <Form.Control
              disabled={disabled}
              isValid={!meta.error && meta.touched}
              isInvalid={!!meta.error && meta.touched}
              hidden
            ></Form.Control>
            <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
          </Form.Group>
        )}
      </Field>
    </div>
  );
};
